import React from 'react';
import Section from '../section/section';
import Breadcrumbs, { type IBreadcrumb } from '../../../components/breadcrumbs/breadcrumbs';
import { Tag } from '../../../components/tag/tag-component';
import TableOfContents, { type AnchorLink } from '../../../components/table-of-contents/table-of-contents';
import {
  ITestimonialSecondaryProps,
  TestimonialSecondary,
} from '../../../components/testimonial/testimonial-secondary/testimonial-secondary';

interface IArticlePrimarySection {
  breadcrumbs: IBreadcrumb[];
  title: string;
  description: string;
  image: { src: string; alt: string };
  timeToRead: string;
  category: string;
  createdAt: string;
  articleAnchors?: AnchorLink[];
  testimonial?: ITestimonialSecondaryProps;
}

export default function ArticlePrimarySection({
  breadcrumbs,
  testimonial,
  articleAnchors = [],
  title,
  description,
  image,
  timeToRead,
  category,
  createdAt,
}: IArticlePrimarySection) {
  return (
    <section
      style={{ background: 'linear-gradient(90deg, rgba(169, 87, 226, 0.08) 0%, rgba(55, 148, 212, 0.08) 100%)' }}>
      <Section className="article-primary-section">
        <Breadcrumbs links={breadcrumbs} />

        <div className="article-primary-section__wrapper">
          <div className="article-primary-section__content">
            <h1 className="article-primary-section__content__title">{title}</h1>
            <p className="article-primary-section__content__description">{description}</p>
            <div className="article-primary-section__content__info">
              <div className="article-primary-section__content__info__date">
                {formatDateToString(new Date(createdAt))}
              </div>
              <div className="article-primary-section__content__info__time-to-read">{timeToRead}</div>
            </div>
            <div className="article-primary-section__content__image">
              <img src={image.src} alt={image.alt} />
            </div>
          </div>

          <aside className="article-primary-section__aside">
            <div className="article-primary-section__aside__time-to-read">{timeToRead}</div>
            <div className="article-primary-section__aside__date">{formatDateToString(new Date(createdAt))}</div>
            <Tag text={{ text: category }} />
            <TableOfContents links={articleAnchors} />
            {testimonial && <TestimonialSecondary {...testimonial} />}
          </aside>
        </div>
      </Section>
    </section>
  );
}

function formatDateToString(date: Date) {
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
